import VListButton from './index.vue';

export default {
  install: (Vue) => Vue.component('VListButton', VListButton),
};
